import { render } from "./InitiativesView.vue?vue&type=template&id=4c509a41&scoped=true"
import script from "./InitiativesView.vue?vue&type=script&lang=js"
export * from "./InitiativesView.vue?vue&type=script&lang=js"

import "./InitiativesView.vue?vue&type=style&index=0&id=4c509a41&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c509a41"]])

export default __exports__